__turbopack_context__.v({
  "shop_icon": "Vy1q0G_shop_icon",
  "shop_link": "Vy1q0G_shop_link",
  "shop_menu": "Vy1q0G_shop_menu",
  "shop_menu_inner": "Vy1q0G_shop_menu_inner",
  "shop_menu_item": "Vy1q0G_shop_menu_item",
});
